import { Link } from 'react-router';
import { paths } from '@/routes/paths';

/** Self-service reset (OTP) is planned for Phase 1; until then an administrator resets it. */
export function ForgotPasswordPage() {
  return (
    <>
      <h1 className="mb-3 text-center text-2xl font-medium text-ink-strong">Forgot Password</h1>
      <p className="mb-6 text-center text-sm text-muted">
        Password reset is not available online yet. Please contact your administrator to reset your
        password.
      </p>
      <Link
        to={paths.login}
        className="block rounded-full bg-brand px-5 py-2.5 text-center text-[15px] font-medium text-white hover:bg-brand-dark"
      >
        Back to Sign In
      </Link>
    </>
  );
}
